import * as React from "react";
import "./HeroNavigation.scss";

export const NextArrow = ({ onClick }) => (
  <div>
    <div className="next-arrow" onClick={onClick} />
  </div>
);
